// Theme: prefers-color-scheme by default, optional manual toggle persisted in
// localStorage (DESIGN.md 5.4, Q-Design-2). Applied via data-theme on <html>.

type ThemePref = 'light' | 'dark' | 'system';

const STORAGE_KEY = 'luo-theme';

function readPref(): ThemePref {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch {
    // localStorage may be unavailable; fall back to system.
  }
  return 'system';
}

function apply(pref: ThemePref) {
  const root = document.documentElement;
  if (pref === 'system') {
    root.removeAttribute('data-theme');
  } else {
    root.setAttribute('data-theme', pref);
  }
}

export function initTheme() {
  apply(readPref());
  // React to system changes when in system mode.
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (readPref() === 'system') apply('system');
  });
}

export function setTheme(pref: ThemePref) {
  try {
    localStorage.setItem(STORAGE_KEY, pref);
  } catch {
    // ignore storage errors
  }
  apply(pref);
}

export function currentTheme(): ThemePref {
  return readPref();
}
